import { render, staticRenderFns } from "./form-init.vue?vue&type=template&id=1cb7f459&"
import script from "./form-init.vue?vue&type=script&lang=js&"
export * from "./form-init.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports